export default __webpack_public_path__ + "static/media/tap.f733f876.svg";